var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getLoggableAxiosError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        request: {
            method: (_a = error.config) === null || _a === void 0 ? void 0 : _a.method,
            baseURL: (_b = error.config) === null || _b === void 0 ? void 0 : _b.baseURL,
            url: (_c = error.config) === null || _c === void 0 ? void 0 : _c.url,
            headers: (_d = error.config) === null || _d === void 0 ? void 0 : _d.headers,
        },
        response: { statusCode: (_e = error.response) === null || _e === void 0 ? void 0 : _e.status, data: (_f = error.response) === null || _f === void 0 ? void 0 : _f.data },
    });
};
var logger = {
    key: "console",
    setValue: function (payload) {
        console.log("Set value: ", payload);
    },
    logEvent: function (payload) {
        console.log("Log event: ", payload);
    },
    logError: function (payload) {
        var loggableAxiosError;
        var axiosError = payload.error;
        if (axiosError.isAxiosError) {
            loggableAxiosError = getLoggableAxiosError(axiosError);
        }
        console.error("Log error: ", __assign(__assign({}, payload), { loggableAxiosError: loggableAxiosError }));
    },
};
// eslint-disable-next-line import/no-default-export
export default logger;
